module.exports = __webpack_public_path__ + "static/media/pic_ditie_wap.b723f7e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_temperature/pic_ditie_wap.png
// module id = 500
// module chunks = 0